import Button from "core-web/components/base/Button";
import PlusIcon from "theme/components/icons/PlusIcon";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";

const Wrapper = styled(Button)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 100%;
`;

const AccordionHeader = ({ label, active, padding, onclick }) => (
    <Wrapper padding={padding} onClick={onclick}>
        <TextStyles as="h3" textStyles="Myriad Pro/20-100-semibold">
            {label}
        </TextStyles>
        <PlusIcon height="12px" width="auto" isActive={active} color={colors.black} />
    </Wrapper>
);

AccordionHeader.propTypes = {
    active: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onclick: PropTypes.func,
    padding: PropTypes.array,
};

AccordionHeader.defaultProps = {
    active: false,
    onclick: () => null,
    padding: "24px 0",
};

export default AccordionHeader;
